// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__2c30C","avatar":"style_avatar__KldG+","surplus":"style_surplus__-NcCD"};